<template>
  <f7-page>
    <navbar :text="$t('LeftPanel_subtitle_floor')" />
    <DxFloor
      :current-floor="currentFloor"
      :current-useful-life="currentUsefulLife"
      :current-percentage-of-stoniness="currentPercentageOfStoniness"
    />
    <f7-button
      class="button-next-screen"
      raised
      type="default"
      text-color="grey"
      styling-mode="outlined"
      @click="goToIrrigation"
    >
      {{ $t('Continue') }}
    </f7-button>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DxFloor from '../components/DxFloor.vue';
import navbar from '../components/NavBar.vue';

export default {
  components: {
    DxFloor,
    navbar,
  },
  computed: {
    getFloorData() {
      return {
        currentFloor: this.currentFloor,
        currentUsefulLife: this.currentUsefulLife,
        currentPercentageOfStoniness: this.currentPercentageOfStoniness,
      };
    },
    ...mapState('Mopeco', ['currentFloor', 'currentUsefulLife', 'currentPercentageOfStoniness']),
  },
  methods: {
    goToIrrigation() {
      const error = this.$helpers.validateFloorData(this.getFloorData);
      if (error !== '') {
        this.$f7.dialog.alert(this.$t(error));
        this.setShowIrrigation(false);
        return;
      }
      this.setShowIrrigation(true);
      this.$f7.views.main.router.navigate('/irrigation/');
    },
    ...mapActions('Mopeco', ['setShowIrrigation']),
  },
};
</script>

<style>

</style>
